







import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import BScroll from "better-scroll";
@Component
export default class Scroller extends Vue {
  scroll: any = null;
  @Prop({ type: Number, default: 500 }) height!: number;
  @Prop({ type: Number, default: 20 }) refreshDelay!: number;
  @Prop({ type: Array, default: () => [] }) data!: [];
  @Prop({ type: Boolean, default: false }) listenScroll!: false;
  @Prop({ type: Boolean, default: true }) click!: boolean;
  @Prop({ type: Boolean, default: false }) scrollX!: boolean;
  @Prop({ type: Boolean, default: true }) scrollY!: boolean;
  @Prop({ type: Boolean, default: false }) pullup!: boolean;
  @Prop({ type: Boolean, default: false }) beforeScroll!: boolean;
  @Prop({ type: Number, default: 1 }) probeType!: number;
  @Prop() scrollToDetailElement!: any;
  @Watch("data", { immediate: true, deep: true })
  onDataChange() {
    setTimeout(() => {
      this.refresh();
    }, this.refreshDelay);
  }

  initScroll() {
    if (!this.$refs.wrapper) {
      return;
    }
    // 根据自己的需求传入配置项
    this.scroll = new BScroll(this.$refs.wrapper, {
      probeType: this.probeType,
      click: this.click,
      scrollX: this.scrollX
    });

    if (this.listenScroll) {
      let me = this;
      this.scroll.on("scroll", (pos: any) => {
        me.$emit("scroll", pos);
      });
    }

    if (this.pullup) {
      this.scroll.on("scrollEnd", (ev: any) => {
        if (this.scroll.y <= this.scroll.maxScrollY + 50) {
          this.$emit("scrollToEnd", ev);
        }
      });
    }

    if (this.beforeScroll) {
      this.scroll.on("beforeScrollStart", () => {
        this.$emit("beforeScroll");
      });
    }
  }

  disable() {
    this.scroll && this.scroll.disable();
  }
  enable() {
    this.scroll && this.scroll.enable();
  }
  refresh() {
    this.scroll && this.scroll.refresh();
  }
  scrollTo() {
    this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
  }
  scrollToElement() {
    this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
  }

  mounted() {
    this.$nextTick(() => {
      this.initScroll();
    });

    this.$nextTick(() => {
      if (this.scrollToDetailElement) {
        this.scroll.scrollToElement(this.scrollToDetailElement, 0, 0);
      }
    });
  }
}
